<template>
  <custom-callout
    :border-color="statusColor"
    class-main="mt-3 rounded"
    :has-toggle="false"
  >
    <div class="row py-1 mr-md-0">
      <div
        class="col col-md-3 text-center border-right d-flex align-items-center justify-content-center"
      >
        <div
          :class="
            `badge badge-pill font-16 py-2 mt-2 w-90 mx-auto color-black bg-${statusColor}`
          "
        >
          {{ contractStatusName }}
        </div>
      </div>
      <div class="col-12 col-md-9">
        <div class="row pt-2">
          <div class="col col-sm col-12 pl-4">
            <span class="color-gray-6 d-block font-14">
              Número de Solicitud:
            </span>
            <span class="font-16 color-black">
              {{ data.requestNumber | empty }}
            </span>
          </div>
          <div class="col col-sm col-12 pl-4 mt-3 mt-md-0">
            <span class="color-gray-6 d-block font-14">Estudiante:</span>
            <span class="font-16 color-black">
              {{ data.studentFullName }}
            </span>
          </div>
          <div class="col col-sm col-12 pl-4 mt-3 mt-md-0">
            <span class="color-gray-6 d-block font-14">
              Servicio / Disciplina:
            </span>
            <span class="font-16 color-black">
              {{ serviceDisciplineName }}
            </span>
          </div>
          <div class="col col-sm col-12 pl-4 mt-3 mt-md-0">
            <span class="color-gray-6 d-block font-14">
              Estatus de Aprobación:
            </span>
            <div class="font-16 color-black">
              <span
                class="fas fa-circle mr-2"
                :class="`color-${serviceStatusColor}`"
              />
              {{ data.requestServiceStatusName }}
            </div>
          </div>
          <div class="col">
            <action-button
              v-if="canSelectService"
              i="fas fa-check"
              text="Seleccionar"
              variant="outline-success m-2 px-4"
              @click="$emit('on-select-service')"
            />
          </div>
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
//libs components
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';

//constants
import requestServiceStatuses from '@/utils/constants/requestServiceStatuses.js';
import rpContractStatus, {
  rpContractStatusColor,
} from '@/utils/constants/rpContractStatus.js';

export default {
  name: 'SearchRequestRow',
  components: {
    CustomCallout,
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    signedWithAnotherCompany: {
      type: Boolean,
      default: () => false,
    },
    notApprovedForPrinting: {
      type: Boolean,
      default: () => false,
    },
    isCompensatoryService: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    canSelectService() {
      return (
        this.data.statusId == 0 &&
        !this.signedWithAnotherCompany &&
        !this.notApprovedForPrinting &&
        (!this.isCompensatoryService || this.hasCompensatoryCreationPermission)
      );
    },
    serviceDisciplineName() {
      return this.data.disciplineTypeName
        ? `${this.data.requestServiceTypeName} - ${this.data.disciplineTypeName}`
        : this.data.requestServiceTypeName;
    },
    contractStatusName() {
      if (
        this.isCompensatoryService &&
        !this.hasCompensatoryCreationPermission
      ) {
        return 'No Disponible';
      }
      return this.data.statusName;
    },
    statusColor() {
      if (
        this.isCompensatoryService &&
        !this.hasCompensatoryCreationPermission
      ) {
        return rpContractStatusColor[rpContractStatus.NotAvailable];
      }
      if (!this.data.statusId) {
        return rpContractStatusColor[rpContractStatus.Approved];
      }

      return {
        [rpContractStatus.NotAvailable]:
          rpContractStatusColor[rpContractStatus.NotAvailable],
        [rpContractStatus.New]: rpContractStatusColor[rpContractStatus.New],
        [rpContractStatus.Submitted]:
          rpContractStatusColor[rpContractStatus.Submitted],
        [rpContractStatus.Approved]:
          rpContractStatusColor[rpContractStatus.Approved],
        [rpContractStatus.Denied]:
          rpContractStatusColor[rpContractStatus.Denied],
        [rpContractStatus.ApprovedContractInformation]:
          rpContractStatusColor[rpContractStatus.ApprovedContractInformation],
        [rpContractStatus.DeniedContractInformation]:
          rpContractStatusColor[rpContractStatus.DeniedContractInformation],
        [rpContractStatus.Signed]:
          rpContractStatusColor[rpContractStatus.Signed],
        [rpContractStatus.ContractCanceled]:
          rpContractStatusColor[rpContractStatus.ContractCanceled],
        [rpContractStatus.ContractAmended]:
          rpContractStatusColor[rpContractStatus.ContractAmended],
        [rpContractStatus.InSigningProcess]:
          rpContractStatusColor[rpContractStatus.SignatureProcess],
      }[this.data.statusId ?? rpContractStatus.Unset];
    },
    serviceStatusColor() {
      return {
        [requestServiceStatuses.New]: 'yellow',
        [requestServiceStatuses.Approved]: 'green-light',
        [requestServiceStatuses.Objected]: 'purple',
        [requestServiceStatuses.Cancelled]: 'brown',
      }[this.data.requestServiceStatusId];
    },
    hasCompensatoryCreationPermission() {
      return this.userHasPermissions('rempro.contract.tccreation');
    },
  },
  methods: {},
};
</script>
